<template>
  <div v-if="items.length > 0" class="">
    <table class="table">
      <thead>
        <tr>
          <th class="head" colspan="3">Latest Reviews</th>
        </tr>
      </thead>
      <tbody class="body">
        <template v-for="(item, j) in items">
          <tr class="row-table" :key="item.id">
            <td
              width="25%"
              :class="{ claro: j % 2 == 0, oscuro: j % 2 == 1 }"
              class="text"
            >
              <span class="rating" v-if="item.show.rating">
                {{ item.show.rating }} / 5
                <font-awesome-icon
                  class="form--icon"
                  color="#F3C033"
                  icon="star"
                />
              </span>
              <span class="rating" v-else> N/A </span>
            </td>
            <td
              :class="{ claro: j % 2 == 0, oscuro: j % 2 == 1 }"
              class="value"
              width="55%"
            >
              <div>
                <a
                  style="text-decoration: none"
                  :href="`/reviews/${item.id}/${item.slug}`"
                >
                  {{ item.show.title }}
                </a>
              </div>
            </td>
            <td
              width="20%"
              :class="{
                claro: j % 2 == 0,
                oscuro: j % 2 == 1,
              }"
              class="value"
            >
              <figure v-if="item.imgPlatform" class="table-item-platform">
                <img
                  width="50px"
                  height="30px"
                  :src="item.imgPlatform"
                  :alt="item.platform"
                />
              </figure>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    items: [],
  }),
  computed: mapState(["user", "platforms_temp"]),
  created() {
    this.getInfo();
  },
  watch: {
    "user.country": function () {
      this.getInfo();
    },
    platforms_temp() {
      this.getImagePlatform();
    },
  },
  methods: {
    getInfo() {
      const params = { country: this.user.country };
      this.$Parse.Cloud.run("getLatestReviews", params)
        .then((res) => {
          this.items = res.map(function callback(currentValue) {
            const searchRegExp = /\s/g;
            const replaceWith = "-";
            currentValue.slug = currentValue.title.replace(
              searchRegExp,
              replaceWith
            );
            currentValue.imgPlatform = null;
            currentValue.platform = null;
            return currentValue;
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => this.getImagePlatform());
    },
    getImagePlatform() {
      if (this.platforms_temp && this.items) {
        let platforms = this.platforms_temp;
        this.items = this.items.map(function callback(currentValue) {
          if (currentValue.show.platforms && currentValue.show.platforms[0]) {
            const i = platforms.findIndex(
              (el) => el.name == currentValue.show.platforms[0].platform
            );
            if (i != -1) {
              currentValue.imgPlatform = platforms[i].imageUrl;
              currentValue.platform = platforms[i].name;
            }
          }
          return currentValue;
        });
      }
    },
  },
};
</script>

<style scoped>
.table {
  border-collapse: collapse;
  width: 100%;
}
.head {
  border-radius: 5px 5px 0 0;
}
.table > tbody > tr:last-child > td {
  border-radius: 0 0 0px 5px;
}
.table > tbody > tr:last-child > td:last-child {
  border-radius: 0 0 5px 0px;
}
.head {
  background-color: #ff5f5f;
  font-weight: 800;
  text-align: center;
  font-size: 1.2em;
  padding: 7px 0;
}

.headline-2 {
  font-size: 0.9rem;
  background-color: #1c2531;
  height: 40px;
}
.body > tr > td {
  height: 35px;
  font-size: 0.8rem;
  text-align: center;
  border-top: 1px solid #738092;
}
.title {
  text-align: center;
  font-weight: 600;
  border: 1px solid #738092;
  padding-top: 13px;
}

.value {
  border-left: 1px solid #738092;
  color: #cacaca;
}
.row-table:hover .value {
  color: #94c659;
  font-weight: bold;
  cursor: pointer;
}
.row-table:hover .text {
  color: white;
  font-weight: bold;
}

.claro {
  background-color: #375072;
}
.oscuro {
  background-color: #284060;
}

.divider {
  height: 60px;
}

.table-item-platform {
  margin: 5px;
  padding: 0;
}
.table-item-platform > img {
  border-radius: 5px;

  object-fit: cover;
}
.rating {
  margin-right: 10%;
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.8em;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.7em;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.7em;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.6em;
  }
}

@media (max-width: 600px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.5em;
  }
}
</style>
